import {KTCard, KTCardBody} from '../../../../_websoft/helpers'
import {ToastContainer} from 'react-toastify'
import React from 'react'

const Termopaneli: React.FC = () => {
    // small helper for inline style (still same component, no reusable components)
    const tileStyle = (bg: string) =>
        ({
            background: bg,
            borderRadius: 16,
            textDecoration: 'none',
            display: 'block',
            minHeight: 140,
        } as React.CSSProperties)

    const iconWrapStyle =
        ({
            width: 52,
            height: 52,
            borderRadius: 14,
            background: 'rgba(255,255,255,0.16)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            boxShadow: '0 8px 20px rgba(0,0,0,0.08)',
        } as React.CSSProperties)

    return (
        <KTCard>
            <ToastContainer />
            <KTCardBody className='py-4'>
                <div className='container-fluid px-0 px-md-3'>
                    {/* Header */}
                    <div className='d-flex flex-column flex-md-row align-items-start align-items-md-center justify-content-between gap-3 mb-5'>
                        <div>
                            <div className='text-muted fw-semibold mb-1'>Terminal</div>
                            <h1 className='fw-bolder text-gray-900 mb-0'>Termopaneli</h1>
                            <div className='text-muted mt-2'>
                                Odaberi akciju ispod. Na mobitelu prevuci po potrebi – kartice su velike i pregledne.
                            </div>
                        </div>

                        <span className='badge bg-light text-dark p-3'>
              Modul: <span className='fw-bold'>Termoizolacioni paneli</span>
            </span>
                    </div>

                    {/* Section 1 */}
                    <div className='mb-4'>
                        <div className='d-flex align-items-center justify-content-between mb-3'>
                            <div>
                                <div className='text-muted small'>Proizvodnja / izvještaji</div>
                                <div className='fw-bolder fs-4'>Pregled</div>
                            </div>
                        </div>

                        <div className='row g-4'>
                            <div className='col-12 col-md-6 col-xl-4'>
                                <a
                                    href='termopaneli/lista'
                                    className='card hoverable border-0 shadow-sm text-white'
                                    style={tileStyle('linear-gradient(135deg, #0d6efd 0%, #0b5ed7 100%)')}
                                >
                                    <div className='card-body p-4 p-md-5 d-flex flex-column justify-content-between'>
                                        <div className='d-flex align-items-center justify-content-between'>
                                            <div style={iconWrapStyle}>
                                                <i className='bi bi-gear-wide-connected fs-2 text-white' />
                                            </div>
                                            <i className='bi bi-arrow-right-circle fs-2 opacity-75' />
                                        </div>

                                        <div className='mt-4'>
                                            <div className='fw-bolder fs-2 mb-1'>Proizvodnja</div>
                                            <div className='fw-semibold opacity-75'>Lista / rad sa proizvodnjom</div>
                                        </div>
                                    </div>
                                </a>
                            </div>

                            <div className='col-12 col-md-6 col-xl-4'>
                                <a
                                    href='termopaneli/glavna-knjiga-dodaj'
                                    className='card hoverable border-0 shadow-sm text-white'
                                    style={tileStyle('linear-gradient(135deg, #0d6efd 0%, #0a58ca 100%)')}
                                >
                                    <div className='card-body p-4 p-md-5 d-flex flex-column justify-content-between'>
                                        <div className='d-flex align-items-center justify-content-between'>
                                            <div style={iconWrapStyle}>
                                                <i className='bi bi-journal-text fs-2 text-white' />
                                            </div>
                                            <i className='bi bi-arrow-right-circle fs-2 opacity-75' />
                                        </div>

                                        <div className='mt-4'>
                                            <div className='fw-bolder fs-2 mb-1'>Glavna knjiga</div>
                                            <div className='fw-semibold opacity-75'>Unos / evidencija proizvodnje</div>
                                        </div>
                                    </div>
                                </a>
                            </div>

                            <div className='col-12 col-md-6 col-xl-4'>
                                <a
                                    href='termopaneli/dnevni-izvjestaj'
                                    className='card hoverable border-0 shadow-sm text-white'
                                    style={tileStyle('linear-gradient(135deg, #0d6efd 0%, #084298 100%)')}
                                >
                                    <div className='card-body p-4 p-md-5 d-flex flex-column justify-content-between'>
                                        <div className='d-flex align-items-center justify-content-between'>
                                            <div style={iconWrapStyle}>
                                                <i className='bi bi-bar-chart-line fs-2 text-white' />
                                            </div>
                                            <i className='bi bi-arrow-right-circle fs-2 opacity-75' />
                                        </div>

                                        <div className='mt-4'>
                                            <div className='fw-bolder fs-2 mb-1'>Dnevni izvještaj</div>
                                            <div className='fw-semibold opacity-75'>Pregled i statistika</div>
                                        </div>
                                    </div>
                                </a>
                            </div>
                        </div>
                    </div>

                    {/* Section 2 */}
                    <div className='mt-6'>
                        <div className='d-flex align-items-center justify-content-between mb-3'>
                            <div>
                                <div className='text-muted small'>Nalozi / skladište / isporuke</div>
                                <div className='fw-bolder fs-4'>Operacije</div>
                            </div>
                        </div>

                        <div className='row g-4'>
                            <div className='col-12 col-md-6 col-xl-4'>
                                <a
                                    href='termopaneli/nalog-start'
                                    className='card hoverable border-0 shadow-sm text-white'
                                    style={tileStyle('linear-gradient(135deg, #111111 0%, #2b2b2b 100%)')}
                                >
                                    <div className='card-body p-4 p-md-5 d-flex flex-column justify-content-between'>
                                        <div className='d-flex align-items-center justify-content-between'>
                                            <div style={iconWrapStyle}>
                                                <i className='bi bi-play-circle fs-2 text-white' />
                                            </div>
                                            <i className='bi bi-arrow-right-circle fs-2 opacity-75' />
                                        </div>
                                        <div className='mt-4'>
                                            <div className='fw-bolder fs-2 mb-1'>Nalog | Start</div>
                                            <div className='fw-semibold opacity-75'>Pokreni proces naloga</div>
                                        </div>
                                    </div>
                                </a>
                            </div>

                            <div className='col-12 col-md-6 col-xl-4'>
                                <a
                                    href='termopaneli/aktivni-nalozi'
                                    className='card hoverable border-0 shadow-sm text-white'
                                    style={tileStyle('linear-gradient(135deg, #111111 0%, #1f2937 100%)')}
                                >
                                    <div className='card-body p-4 p-md-5 d-flex flex-column justify-content-between'>
                                        <div className='d-flex align-items-center justify-content-between'>
                                            <div style={iconWrapStyle}>
                                                <i className='bi bi-list-task fs-2 text-white' />
                                            </div>
                                            <i className='bi bi-arrow-right-circle fs-2 opacity-75' />
                                        </div>
                                        <div className='mt-4'>
                                            <div className='fw-bolder fs-2 mb-1'>Aktivni nalozi</div>
                                            <div className='fw-semibold opacity-75'>Pregled naloga u toku</div>
                                        </div>
                                    </div>
                                </a>
                            </div>

                            <div className='col-12 col-md-6 col-xl-4'>
                                <a
                                    href='termopaneli/promet-rolne'
                                    className='card hoverable border-0 shadow-sm text-white'
                                    style={tileStyle('linear-gradient(135deg, #111111 0%, #374151 100%)')}
                                >
                                    <div className='card-body p-4 p-md-5 d-flex flex-column justify-content-between'>
                                        <div className='d-flex align-items-center justify-content-between'>
                                            <div style={iconWrapStyle}>
                                                <i className='bi bi-arrow-left-right fs-2 text-white' />
                                            </div>
                                            <i className='bi bi-arrow-right-circle fs-2 opacity-75' />
                                        </div>
                                        <div className='mt-4'>
                                            <div className='fw-bolder fs-2 mb-1'>Promet rolne</div>
                                            <div className='fw-semibold opacity-75'>Evidentiranje utroška</div>
                                        </div>
                                    </div>
                                </a>
                            </div>

                            <div className='col-12 col-md-6 col-xl-4'>
                                <a
                                    href='termopaneli/isporuci-paket'
                                    className='card hoverable border-0 shadow-sm text-white'
                                    style={tileStyle('linear-gradient(135deg, #0dcaf0 0%, #087990 100%)')}
                                >
                                    <div className='card-body p-4 p-md-5 d-flex flex-column justify-content-between'>
                                        <div className='d-flex align-items-center justify-content-between'>
                                            <div style={iconWrapStyle}>
                                                <i className='bi bi-box-arrow-up-right fs-2 text-white' />
                                            </div>
                                            <i className='bi bi-arrow-right-circle fs-2 opacity-75' />
                                        </div>
                                        <div className='mt-4'>
                                            <div className='fw-bolder fs-2 mb-1'>Isporuči paket</div>
                                            <div className='fw-semibold opacity-75'>Isporuka standardnih paketa</div>
                                        </div>
                                    </div>
                                </a>
                            </div>

                            <div className='col-12 col-md-6 col-xl-4'>
                                <a
                                    href='termopaneli/thermoboard-paketi'
                                    className='card hoverable border-0 shadow-sm text-dark'
                                    style={tileStyle('linear-gradient(135deg, #ffc107 0%, #ffda6a 100%)')}
                                >
                                    <div className='card-body p-4 p-md-5 d-flex flex-column justify-content-between'>
                                        <div className='d-flex align-items-center justify-content-between'>
                                            <div style={{...iconWrapStyle, background: 'rgba(0,0,0,0.10)'}}>
                                                <i className='bi bi-boxes fs-2 text-dark' />
                                            </div>
                                            <i className='bi bi-arrow-right-circle fs-2 opacity-75 text-dark' />
                                        </div>
                                        <div className='mt-4'>
                                            <div className='fw-bolder fs-2 mb-1'>Thermoboard paket</div>
                                            <div className='fw-semibold opacity-75'>
                                                Isporuči / Proizvedi termoboard paket
                                            </div>
                                        </div>
                                    </div>
                                </a>
                            </div>

                            <div className='col-12 col-md-6 col-xl-4'>
                                <a
                                    href='termopaneli/isporuci-paket-druga-klasa'
                                    className='card hoverable border-0 shadow-sm text-white'
                                    style={tileStyle('linear-gradient(135deg, #198754 0%, #0f5132 100%)')}
                                >
                                    <div className='card-body p-4 p-md-5 d-flex flex-column justify-content-between'>
                                        <div className='d-flex align-items-center justify-content-between'>
                                            <div style={iconWrapStyle}>
                                                <i className='bi bi-check2-circle fs-2 text-white' />
                                            </div>
                                            <i className='bi bi-arrow-right-circle fs-2 opacity-75' />
                                        </div>
                                        <div className='mt-4'>
                                            <div className='fw-bolder fs-2 mb-1'>Paket 2. klasa</div>
                                            <div className='fw-semibold opacity-75'>Isporuka druge klase</div>
                                        </div>
                                    </div>
                                </a>
                            </div>

                            <div className='col-12 col-md-6 col-xl-4'>
                                <a
                                    href='termopaneli/redomat'
                                    className='card hoverable border-0 shadow-sm text-white'
                                    style={tileStyle('linear-gradient(135deg, #111111 0%, #2b2b2b 100%)')}
                                >
                                    <div className='card-body p-4 p-md-5 d-flex flex-column justify-content-between'>
                                        <div className='d-flex align-items-center justify-content-between'>
                                            <div style={iconWrapStyle}>
                                                <i className='bi bi-truck-front fs-2 text-white' />
                                            </div>
                                            <i className='bi bi-arrow-right-circle fs-2 opacity-75' />
                                        </div>
                                        <div className='mt-4'>
                                            <div className='fw-bolder fs-2 mb-1'>Redomat</div>
                                            <div className='fw-semibold opacity-75'>Utovar / evidencije</div>
                                        </div>
                                    </div>
                                </a>
                            </div>
                        </div>

                        {/* Small hint */}
                        <div className='text-muted small mt-4'>
                            Tip: Na mobitelu prevuci ekran ako bude potrebno, kartice su optimizovane za dodir.
                        </div>
                    </div>
                </div>
            </KTCardBody>
        </KTCard>
    )
}

export default Termopaneli
